import { wrapReducer } from "@client/content/lib/helper";
import { EMPTY_OBJECT } from "@client/lib/misc";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type InitSuccessActionData, type SetModalVisibleActionData } from "./actions";
import { type OptInFormV2 } from "./types";

const reducer = (state: OptInFormV2.AppState, action: ReduxAction<any>): OptInFormV2.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { consentFieldIds, fields, isAllowed, countryCode } = action.data as InitSuccessActionData;
      return {
        ...state,
        consentFieldIds,
        fields,
        isAllowed,
        countryCode,
        status: Status.Ready
      };
    }

    case Actions.SetModalVisible: {
      const { isVisible } = action.data as SetModalVisibleActionData;
      return {
        ...state,
        isModalVisible: isVisible
      };
    }
    default:
      return state;
  }
};

export const defaultState: OptInFormV2.AppState = {
  consentFieldIds: [],
  id: "",
  error: null,
  fieldErrors: {},
  fields: [],
  isAllowed: false,
  isModalVisible: false,
  countryCode: null,
  message: null,
  status: Status.None,
  formData: {
    fields: EMPTY_OBJECT,
    consent: EMPTY_OBJECT,
    customFields: EMPTY_OBJECT
  }
};
export const previewState: OptInFormV2.AppState = {
  ...defaultState,
  fields: [{ formControlKey: "Email", formFieldId: "email", id: "email", isCustom: false, name: "Email" }],
  isAllowed: true,
  status: Status.Ready
};
export default wrapReducer({ defaultState, reducer, previewState });
